<div *ngIf="isOpen" class="fixed inset-0 z-[100] flex items-center justify-center " role="dialog" aria-modal="true"
  [@backdropAnimation]>
  <div class="absolute inset-0 bg-gray-500/75  dark:bg-secondary-500/75" (click)="hasBackdrop && !preventBackdropClose && close()" (keydown.enter)="hasBackdrop && !preventBackdropClose && close()"></div>

  <div
    class="relative bg-white dark:bg-gray-800  overflow-hidden shadow-lg z-50 w-full border-gray-600 border-[1px] "
    [ngClass]="className + (isMobile? ' h-full' : ' rounded-[16px]') " [@modalAnimation]>

    <!-- Header Section (optional) -->
    <div *ngIf="title" [ngClass]=" 'w-full  flex flex-row items-center justify-between  border-b border-gray-1300 '+ (isMobile? 'p-[16px]' : 'px-[24px] py-[29.5px]')">
      <div class="flex flex-row items-center justify-center gap-[16px]">
      <NiFormIcon *ngIf="isMobile" icon="modalDown" iconClass="!w-[40px] !h-[40px] cursor-pointer" (click)="hasBackdrop && !preventBackdropClose && close()" (keydown.enter)="hasBackdrop && !preventBackdropClose && close()" />
      <span class="lg:text-[20px] md:text-[20px] sm:text-[20px] xs:text-[20px] text-[16px] leading-[32px] lg:font-bold md:font-bold sm:font-bold xs:font-bold font-semibold text-black dark:text-white">{{ title }}</span>
      </div>
      <NiFormIcon *ngIf="showCancelIcon && !isMobile" [icon]="'x_close'" [iconClass]="'!w-[35px] !h-[35px] cursor-pointer' " (click)="close()" (keydown.enter)="close()"/>
      <NiFormIcon *ngIf="isMobile && showDeleteIcon" [icon]="'delete'" [iconClass]="'!w-[24px] h-[!24px] cursor-pointer'" (click)="delete()" (keydown.enter)="delete()"/>
    </div>

    <!-- Content Section -->
    <div>
      <ng-content></ng-content>
    </div>

    <!-- Footer Section with Action Buttons (optional) -->
    <div *ngIf="showActions" class="p-[1.25rem] flex justify-end gap-[2rem] bg-white border-t  border-gray-1300  dark:bg-gray-700">

      <NiFormButton [label]="cancelText || 'Cancel'" varient="outlined" color="secondary" paddingSize="px24_py_14" [fontSize]="18" [fontWeight]="700" (click)="close()"  (keydown.enter)="close()"/>
      <NiFormButton [label]="confirmText || 'Confirm'" varient="contained" color="primary" paddingSize="px24_py_14" [fontSize]="18" [fontWeight]="700" (click)="confirm()" (keydown.enter)="confirm()"/>

    </div>


  </div>
</div>